import React from "react";
import {
  COMPANY_ADDRESS,
  COMPANY_ADDRESS_GOOGLE_MAPS_LINK,
} from "../../constants/constants";
import { Container, Row, Col } from "react-bootstrap";
import GeoMarkerIcon from "../../images/svg/geo-marker.inline.svg";

export default function Address({ className, iconClassName, textClassName }) {
  return (
    <>
      <Container className={className}>
        <Row>
          <Col xs={1} className="mx-auto pt-1">
            <a
              className={iconClassName}
              href={COMPANY_ADDRESS_GOOGLE_MAPS_LINK}
              target="_blank"
              rel="noreferrer noopener"
              aria-label="Company Address Google Maps Link."
            >
              <span className="pt-5">
                <GeoMarkerIcon />
              </span>
            </a>
          </Col>
          <Col xs={10}>
            <a
              className={textClassName}
              href={COMPANY_ADDRESS_GOOGLE_MAPS_LINK}
              target="_blank"
              rel="noreferrer noopener"
              aria-label="Company Address Google Maps Link."
            >
              <span className="pl-2 pt-0 mt-0">{COMPANY_ADDRESS}</span>
            </a>
          </Col>
        </Row>
      </Container>
    </>
  );
}
